export enum SolarQuoteSteps {
  LEAD = 'LEAD',
  QUOTE = 'QUOTE',
}

export const SolarQuoteStepOrder = [
  SolarQuoteSteps.LEAD,
  SolarQuoteSteps.QUOTE,
];
